$(document).ready(function() {
  if($(window).width()<768) {
    jQuery('.product-single__thumbnails .grid__item').click(function (event) {
        //console.log("test");
        var container = [];
        var $link = jQuery(this).find('img'),
        item = {
            src: $link.attr('src'),
            w: 640,
            h: 960,
            title: $link.attr('alt')
        };
        container.push(item);
        event.preventDefault();
        var $pswp = jQuery('.pswp')[0],
            options = {
                index: jQuery(this).parent('.product-single__thumbnails .grid__item').index(),
                bgOpacity: 0.85,
                showHideOpacity: true
            };
        var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
        gallery.init();
    });
  }  
  if($(window).width()<768) {
    // $('.slideshow__slide--e5ef5728-723a-4202-9737-9b846691cac3 img').attr('src','https://shopbilalgarments.com/cdn/shop/files/shop_NOw_Slider_1500x_d2f3404e-8d16-4125-80bc-23005b9ee36d_1920x.webp?v=1697543988'); //1th
    // $('.slideshow__slide--c61d66c1-d5f6-4230-8961-3b03779708ce img').attr('src','https://shopbilalgarments.com/cdn/shop/files/0005667_WEB-BANNER-004_1920x.jpg?v=1699099642'); //1rd
    // $('.slideshow__slide--1590955812438-0 img').attr('src','https://shopbilalgarments.com/cdn/shop/files/0006014_banner2_1920x.jpg?v=1702716452'); //2st
    
    // $('.slideshow__slide--34680274-1c65-4893-aaee-90f9e2b732bf img').attr('src','https://shopbilalgarments.com/cdn/shop/files/live_now_1_1500x_6d433f3d-1071-43f2-a01d-cc7102aa5f10_1920x.webp?v=1694255223'); //4nd
    
    //  add width & height attributes to slider img
    $('#shopify-section-1590955812438 .slideshow__slide img').attr({
      width: 800,
      height: 500
    });
  }
  else {
    
    //  add width & height attributes to slider img
    $('#shopify-section-1590955812438 .slideshow__slide img').attr({
      width: 1920,
      height: 650
    });
  }
  
  $('#shopify-section-1590955812438 .slideshow__slide img, .site-header .site-header__logo img').addClass('img_height_auto');
  
  $('.site-header .site-header__logo img').attr({
      width: 500,
      height: 158
  });
  
  $('.size-chart-open-popup').magnificPopup({
    type:'inline',
    midClick: true
  });
});

// $('.js-mobile-nav-toggle').on('click', function() {
//   console.log('navtoggle clicked');
//   $('.mobile-nav-wrapper').removeClass('.js-menu--is-open');
// });
 
$(document).ready(function() {
   $(document).ready(function(){
    $('.cart__update').click(function(e){
    //  e.preventDefault();
      var message = 'Cart has been updated.';
      $('#updateMessage').text(message).fadeIn().delay(20000).fadeOut();
    });
  });
//  $('.cart__update').click(function(e){
  //  e.preventDefault(); // Prevent the default form submission behavior
    //alert("Update button clicked!"); // Show the message
  //});
});


$(document).ready(function(){
  $("img.lazyload").lazyload({
    effect: "fadeIn",
    threshold: 200
  });
});
